export const CSV_VALUES = {
  YES: 'はい',
  NO: 'いいえ',
  RETURNS_ACCEPTED: '返品可',
  RETURNS_NOT_ACCEPTED: '返品不可'
} as const;

export type YesNoValue = typeof CSV_VALUES.YES | typeof CSV_VALUES.NO;
export type ReturnsValue = typeof CSV_VALUES.RETURNS_ACCEPTED | typeof CSV_VALUES.RETURNS_NOT_ACCEPTED;